import React from 'react';
import { Router as DefaultRouter, Route, Switch } from 'react-router-dom';
import dynamic from 'umi/dynamic';
import renderRoutes from 'umi/lib/renderRoutes';
import history from '@tmp/history';

const Router = DefaultRouter;

const routes = [
  {
    path: '/exchange',
    redirect: '/exchange/index',
    exact: true,
    _title: '商品中心',
    _title_default: '商品中心',
  },
  {
    path: '/activate',
    redirect: '/activate/index',
    exact: true,
    _title: '商品中心',
    _title_default: '商品中心',
  },
  {
    path: '/coupon',
    redirect: '/coupon/index',
    exact: true,
    _title: '商品中心',
    _title_default: '商品中心',
  },
  {
    path: '/shop',
    redirect: '/shop/index',
    exact: true,
    _title: '商品中心',
    _title_default: '商品中心',
  },
  {
    path: '/toMarketing',
    redirect: '/toMarketing/index',
    exact: true,
    _title: '商品中心',
    _title_default: '商品中心',
  },
  {
    path: '/activity',
    redirect: '/activity/index',
    exact: true,
    _title: '商品中心',
    _title_default: '商品中心',
  },
  {
    path: '/',
    component: __IS_BROWSER
      ? dynamic({
          loader: () => import(/* webpackChunkName: "p__index" */ '../index'),
          loading: require('/home/workspace/code/src/components/Loading')
            .default,
        })
      : require('../index').default,
    redirect: '/item/detail',
    exact: true,
    _title: '商品中心',
    _title_default: '商品中心',
  },
  {
    path: '/index',
    component: __IS_BROWSER
      ? dynamic({
          loader: () => import(/* webpackChunkName: "p__index" */ '../index'),
          loading: require('/home/workspace/code/src/components/Loading')
            .default,
        })
      : require('../index').default,
    redirect: '/item/detail',
    exact: true,
    _title: '商品中心',
    _title_default: '商品中心',
  },
  {
    path: '/item',
    routes: [
      {
        path: '/item/detail',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__item__Detail__index" */ '../item/Detail/index'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../item/Detail/index').default,
        title: '商品详情',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '商品详情',
        _title_default: '商品中心',
      },
      {
        path: '/item/track',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__item__track__index" */ '../item/track/index'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../item/track/index').default,
        title: '续订追踪',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '续订追踪',
        _title_default: '商品中心',
      },
      {
        path: '/item/subscribeDetail',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__item__subscribeDetail" */ '../item/subscribeDetail'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../item/subscribeDetail').default,
        title: '商品详情',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '商品详情',
        _title_default: '商品中心',
      },
      {
        path: '/item/order',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__item__ConfirmOrder__index" */ '../item/ConfirmOrder/index'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../item/ConfirmOrder/index').default,
        title: '确认订单',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '确认订单',
        _title_default: '商品中心',
      },
      {
        path: '/item/pay',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__item__pay" */ '../item/pay'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../item/pay').default,
        title: '确认订单',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '确认订单',
        _title_default: '商品中心',
      },
      {
        path: '/item/subscribeUpgrade',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__item__subscribeUpgrade" */ '../item/subscribeUpgrade'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../item/subscribeUpgrade').default,
        title: '升级订阅',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '升级订阅',
        _title_default: '商品中心',
      },
      {
        path: '/item/share',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__item__Share__index" */ '../item/Share/index'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../item/Share/index').default,
        title: '嗮单',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '嗮单',
        _title_default: '商品中心',
      },
      {
        path: '/item/transition',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__item__transition" */ '../item/transition'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../item/transition').default,
        title: '',
        exact: true,
        _title: '商品中心',
        _title_default: '商品中心',
      },
      {
        component: __IS_BROWSER
          ? dynamic({
              loader: () => import(/* webpackChunkName: "p__404" */ '../404'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../404').default,
        exact: true,
        _title: '商品中心',
        _title_default: '商品中心',
      },
    ],
    _title: '商品中心',
    _title_default: '商品中心',
  },
  {
    path: '/order',
    routes: [
      {
        path: '/order/list',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__list" */ '../order/list'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/list').default,
        title: '订单列表',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '订单列表',
        _title_default: '商品中心',
      },
      {
        path: '/order/detail',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__Detail__detail" */ '../order/Detail/detail'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/Detail/detail').default,
        title: '订单详情',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '订单详情',
        _title_default: '商品中心',
      },
      {
        path: '/order/new-detail',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__Detail__detail" */ '../order/Detail/detail'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/Detail/detail').default,
        title: '订单详情',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '订单详情',
        _title_default: '商品中心',
      },
      {
        path: '/order/preOrderDetail',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__PreOrderDetail__index" */ '../order/PreOrderDetail/index'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/PreOrderDetail/index').default,
        title: '订单详情',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '订单详情',
        _title_default: '商品中心',
      },
      {
        path: '/order/combinedOrderDetail',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__combinedOrderDetail" */ '../order/combinedOrderDetail'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/combinedOrderDetail').default,
        title: '订单详情',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '订单详情',
        _title_default: '商品中心',
      },
      {
        path: '/order/address',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__address" */ '../order/address'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/address').default,
        title: '收货地址列表',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '收货地址列表',
        _title_default: '商品中心',
      },
      {
        path: '/order/productAddressDetail',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__ProductAddressDetail" */ '../order/ProductAddressDetail'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/ProductAddressDetail').default,
        title: '商品列表',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '商品列表',
        _title_default: '商品中心',
      },
      {
        path: '/order/addressList',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__AddressList" */ '../order/AddressList'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/AddressList').default,
        title: '地址列表',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '地址列表',
        _title_default: '商品中心',
      },
      {
        path: '/order/modifyAddressRes',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__ModifyAddressRes" */ '../order/ModifyAddressRes'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/ModifyAddressRes').default,
        title: '修改地址',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '修改地址',
        _title_default: '商品中心',
      },
      {
        path: '/order/pay',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__pay" */ '../order/pay'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/pay').default,
        title: '收银台',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '收银台',
        _title_default: '商品中心',
      },
      {
        path: '/order/alipay',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__alipay" */ '../order/alipay'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/alipay').default,
        title: '收银台',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '收银台',
        _title_default: '商品中心',
      },
      {
        path: '/order/aliScanPay',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__AliScanPay" */ '../order/AliScanPay'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/AliScanPay').default,
        title: '收银台',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '收银台',
        _title_default: '商品中心',
      },
      {
        path: '/order/huaweipay',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__HuaweiPay" */ '../order/HuaweiPay'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/HuaweiPay').default,
        title: '收银台',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '收银台',
        _title_default: '商品中心',
      },
      {
        path: '/order/applePay',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__ApplePay" */ '../order/ApplePay'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/ApplePay').default,
        title: '收银台',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '收银台',
        _title_default: '商品中心',
      },
      {
        path: '/order/aliPayTransfer',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__AliPayTransfer" */ '../order/AliPayTransfer'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/AliPayTransfer').default,
        title: '收银台',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '收银台',
        _title_default: '商品中心',
      },
      {
        path: '/order/pending',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__pending" */ '../order/pending'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/pending').default,
        title: '收银台',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '收银台',
        _title_default: '商品中心',
      },
      {
        path: '/order/protocol',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__protocol" */ '../order/protocol'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/protocol').default,
        title: '购买服务协议',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '购买服务协议',
        _title_default: '商品中心',
      },
      {
        path: '/order/success',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__success" */ '../order/success'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/success').default,
        title: '支付成功',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '支付成功',
        _title_default: '商品中心',
      },
      {
        path: '/order/coupon/success',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__couponSuccess" */ '../order/couponSuccess'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/couponSuccess').default,
        title: '购买成功',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '购买成功',
        _title_default: '商品中心',
      },
      {
        path: '/order/share',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__share" */ '../order/share'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/share').default,
        title: '晒单',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '晒单',
        _title_default: '商品中心',
      },
      {
        path: '/order/create',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__item__ConfirmOrder__index" */ '../item/ConfirmOrder/index'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../item/ConfirmOrder/index').default,
        title: '确认订单',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '确认订单',
        _title_default: '商品中心',
      },
      {
        path: '/order/scanPay',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__scanPay" */ '../order/scanPay'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/scanPay').default,
        title: '支付',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '支付',
        _title_default: '商品中心',
      },
      {
        path: '/order/scanPay/result',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__scanPay__result" */ '../order/scanPay/result'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/scanPay/result').default,
        title: '支付完成',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '支付完成',
        _title_default: '商品中心',
      },
      {
        path: '/order/courseActive',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__courseActive" */ '../order/courseActive'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/courseActive').default,
        title: '课程激活',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '课程激活',
        _title_default: '商品中心',
      },
      {
        path: '/order/pollingResult',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__pollingResult" */ '../order/pollingResult'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/pollingResult').default,
        title: '支付结果查询',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '支付结果查询',
        _title_default: '商品中心',
      },
      {
        path: '/order/wxTicket',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__wxTicket" */ '../order/wxTicket'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/wxTicket').default,
        title: '支付完成',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '支付完成',
        _title_default: '商品中心',
      },
      {
        path: '/order/payRecord',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__payRecord" */ '../order/payRecord'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/payRecord').default,
        title: '开通记录',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '开通记录',
        _title_default: '商品中心',
      },
      {
        path: '/order/invoice',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__Invoice" */ '../order/Invoice'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/Invoice').default,
        title: '申请开票',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '申请开票',
        _title_default: '商品中心',
      },
      {
        path: '/order/invoice-list',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__Invoice__list" */ '../order/Invoice/list'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/Invoice/list').default,
        title: '发票',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '发票',
        _title_default: '商品中心',
      },
      {
        path: '/order/invoiceDetails',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__Invoice__details" */ '../order/Invoice/details'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/Invoice/details').default,
        title: '开票详情',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '开票详情',
        _title_default: '商品中心',
      },
      {
        path: '/order/invoiceDownload',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__Invoice__download" */ '../order/Invoice/download'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/Invoice/download').default,
        title: '电子发票',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '电子发票',
        _title_default: '商品中心',
      },
      {
        path: '/order/changeEntity',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__afterSales__ChangeEntity" */ '../order/afterSales/ChangeEntity'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/afterSales/ChangeEntity').default,
        title: '更换实物',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '更换实物',
        _title_default: '商品中心',
      },
      {
        path: '/order/changeEntity/details',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__afterSales__ChangeEntity__Details" */ '../order/afterSales/ChangeEntity/Details'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/afterSales/ChangeEntity/Details').default,
        title: '更换实物详情',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '更换实物详情',
        _title_default: '商品中心',
      },
      {
        path: '/order/afterSales',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__afterSales__Refund" */ '../order/afterSales/Refund'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/afterSales/Refund').default,
        title: '退款申请',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '退款申请',
        _title_default: '商品中心',
      },
      {
        path: '/order/afterSales/details',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__afterSales__Refund__Details" */ '../order/afterSales/Refund/Details'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/afterSales/Refund/Details').default,
        title: '退款详情',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '退款详情',
        _title_default: '商品中心',
      },
      {
        path: '/order/afterSales/list',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__afterSales__Refund__List" */ '../order/afterSales/Refund/List'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/afterSales/Refund/List').default,
        title: '售后记录',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '售后记录',
        _title_default: '商品中心',
      },
      {
        path: '/order/afterSales/delivery',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__afterSales__Refund__Delivery" */ '../order/afterSales/Refund/Delivery'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/afterSales/Refund/Delivery').default,
        title: '填写发货单',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '填写发货单',
        _title_default: '商品中心',
      },
      {
        path: '/order/changeContent',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__afterSales__ChangeContent" */ '../order/afterSales/ChangeContent'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/afterSales/ChangeContent').default,
        title: '申请更换学习内容',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '申请更换学习内容',
        _title_default: '商品中心',
      },
      {
        path: '/order/changeContent/details',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__afterSales__ChangeContent__Details" */ '../order/afterSales/ChangeContent/Details'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/afterSales/ChangeContent/Details').default,
        title: '换内容详情',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '换内容详情',
        _title_default: '商品中心',
      },
      {
        component: __IS_BROWSER
          ? dynamic({
              loader: () => import(/* webpackChunkName: "p__404" */ '../404'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../404').default,
        exact: true,
        _title: '商品中心',
        _title_default: '商品中心',
      },
    ],
    _title: '商品中心',
    _title_default: '商品中心',
  },
  {
    path: '/address',
    routes: [
      {
        path: '/address/list',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__address__list" */ '../address/list'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../address/list').default,
        title: '收货地址',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '收货地址',
        _title_default: '商品中心',
      },
      {
        path: '/address/edit',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__address__edit" */ '../address/edit'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../address/edit').default,
        title: '修改地址',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '修改地址',
        _title_default: '商品中心',
      },
      {
        path: '/address/editOrderAddress',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__address__EditOrderAddress" */ '../address/EditOrderAddress'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../address/EditOrderAddress').default,
        title: '修改地址',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '修改地址',
        _title_default: '商品中心',
      },
      {
        path: '/address/searchAddress',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__address__SearchAddress__index" */ '../address/SearchAddress/index'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../address/SearchAddress/index').default,
        title: '搜索地址',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '搜索地址',
        _title_default: '商品中心',
      },
      {
        path: '/address/springNotice',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__address__SpringNotice__index" */ '../address/SpringNotice/index'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../address/SpringNotice/index').default,
        title: '公告',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '公告',
        _title_default: '商品中心',
      },
      {
        component: __IS_BROWSER
          ? dynamic({
              loader: () => import(/* webpackChunkName: "p__404" */ '../404'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../404').default,
        exact: true,
        _title: '商品中心',
        _title_default: '商品中心',
      },
    ],
    _title: '商品中心',
    _title_default: '商品中心',
  },
  {
    path: '/delivery',
    routes: [
      {
        path: '/delivery/list',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__delivery__list" */ '../delivery/list'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../delivery/list').default,
        title: '发货列表',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '发货列表',
        _title_default: '商品中心',
      },
      {
        path: '/delivery/detail',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__delivery__detail" */ '../delivery/detail'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../delivery/detail').default,
        title: '物流详情',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '物流详情',
        _title_default: '商品中心',
      },
      {
        path: '/delivery/detailV2',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__delivery__DetailV2__index" */ '../delivery/DetailV2/index'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../delivery/DetailV2/index').default,
        title: '物流详情',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '物流详情',
        _title_default: '商品中心',
      },
      {
        path: '/delivery/listV2',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__delivery__ListV2__index" */ '../delivery/ListV2/index'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../delivery/ListV2/index').default,
        title: '物流信息',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '物流信息',
        _title_default: '商品中心',
      },
      {
        component: __IS_BROWSER
          ? dynamic({
              loader: () => import(/* webpackChunkName: "p__404" */ '../404'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../404').default,
        exact: true,
        _title: '商品中心',
        _title_default: '商品中心',
      },
    ],
    _title: '商品中心',
    _title_default: '商品中心',
  },
  {
    path: '/exchange',
    routes: [
      {
        path: '/exchange/index',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__exchange__index" */ '../exchange/index'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../exchange/index').default,
        title: '兑换码',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '兑换码',
        _title_default: '商品中心',
      },
      {
        path: '/exchange/phone',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__exchange__phoneSearch" */ '../exchange/phoneSearch'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../exchange/phoneSearch').default,
        title: '手机号兑换',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '手机号兑换',
        _title_default: '商品中心',
      },
      {
        path: '/exchange/quota',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__exchange__quota" */ '../exchange/quota'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../exchange/quota').default,
        title: '名额兑换',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '名额兑换',
        _title_default: '商品中心',
      },
      {
        path: '/exchange/quota/matrix',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__exchange__MatrixAppDownload__index" */ '../exchange/MatrixAppDownload/index'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../exchange/MatrixAppDownload/index').default,
        title: '名额兑换',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '名额兑换',
        _title_default: '商品中心',
      },
      {
        path: '/exchange/detail',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__exchange__detail" */ '../exchange/detail'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../exchange/detail').default,
        title: '确认信息',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '确认信息',
        _title_default: '商品中心',
      },
      {
        path: '/exchange/success',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__exchange__success" */ '../exchange/success'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../exchange/success').default,
        title: '叫叫',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '叫叫',
        _title_default: '商品中心',
      },
      {
        component: __IS_BROWSER
          ? dynamic({
              loader: () => import(/* webpackChunkName: "p__404" */ '../404'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../404').default,
        exact: true,
        _title: '商品中心',
        _title_default: '商品中心',
      },
    ],
    _title: '商品中心',
    _title_default: '商品中心',
  },
  {
    path: '/refund',
    routes: [
      {
        path: '/refund/list',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__refund__list" */ '../refund/list'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../refund/list').default,
        title: '退款列表',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '退款列表',
        _title_default: '商品中心',
      },
      {
        path: '/refund/detail',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__refund__detail" */ '../refund/detail'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../refund/detail').default,
        title: '退款详情',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '退款详情',
        _title_default: '商品中心',
      },
      {
        component: __IS_BROWSER
          ? dynamic({
              loader: () => import(/* webpackChunkName: "p__404" */ '../404'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../404').default,
        exact: true,
        _title: '商品中心',
        _title_default: '商品中心',
      },
    ],
    _title: '商品中心',
    _title_default: '商品中心',
  },
  {
    path: '/activate',
    routes: [
      {
        path: '/activate/index',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__activate__index" */ '../activate/index'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../activate/index').default,
        title: '激活码查询',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '激活码查询',
        _title_default: '商品中心',
      },
      {
        path: '/activate/detail',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__activate__detail" */ '../activate/detail'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../activate/detail').default,
        title: '激活码查询',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '激活码查询',
        _title_default: '商品中心',
      },
      {
        component: __IS_BROWSER
          ? dynamic({
              loader: () => import(/* webpackChunkName: "p__404" */ '../404'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../404').default,
        exact: true,
        _title: '商品中心',
        _title_default: '商品中心',
      },
    ],
    _title: '商品中心',
    _title_default: '商品中心',
  },
  {
    path: '/coupon',
    routes: [
      {
        path: '/coupon/index',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__coupon__index" */ '../coupon/index'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../coupon/index').default,
        title: '优惠券',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '优惠券',
        _title_default: '商品中心',
      },
      {
        path: '/coupon/rules',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__coupon__rules" */ '../coupon/rules'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../coupon/rules').default,
        title: '活动规则',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '活动规则',
        _title_default: '商品中心',
      },
      {
        path: '/coupon/mine',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__coupon__mine" */ '../coupon/mine'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../coupon/mine').default,
        title: '优惠券',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '优惠券',
        _title_default: '商品中心',
      },
      {
        path: '/coupon/list',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__coupon__List__index" */ '../coupon/List/index'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../coupon/List/index').default,
        title: '券包',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '券包',
        _title_default: '商品中心',
      },
      {
        path: '/coupon/voucherSelect',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__coupon__VoucherSelect__index" */ '../coupon/VoucherSelect/index'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../coupon/VoucherSelect/index').default,
        title: '代金券',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '代金券',
        _title_default: '商品中心',
      },
      {
        path: '/coupon/use',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__coupon__use" */ '../coupon/use'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../coupon/use').default,
        title: '优惠券',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '优惠券',
        _title_default: '商品中心',
      },
      {
        component: __IS_BROWSER
          ? dynamic({
              loader: () => import(/* webpackChunkName: "p__404" */ '../404'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../404').default,
        exact: true,
        _title: '商品中心',
        _title_default: '商品中心',
      },
    ],
    _title: '商品中心',
    _title_default: '商品中心',
  },
  {
    path: '/shop',
    routes: [
      {
        path: '/shop/index',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__shopList__index" */ '../shopList/index'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../shopList/index').default,
        title: '',
        exact: true,
        _title: '商品中心',
        _title_default: '商品中心',
      },
      {
        path: '/shop/search',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__shopList__components__searchHistory__index" */ '../shopList/components/searchHistory/index'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../shopList/components/searchHistory/index').default,
        title: '商品搜索',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '商品搜索',
        _title_default: '商品中心',
      },
      {
        path: '/shop/searchResult',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__shopList__components__searchResult__index" */ '../shopList/components/searchResult/index'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../shopList/components/searchResult/index').default,
        title: '商品搜索',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '商品搜索',
        _title_default: '商品中心',
      },
      {
        path: '/shop/notice',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__shopList__components__notice__notice" */ '../shopList/components/notice/notice'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../shopList/components/notice/notice').default,
        title: '公告',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '公告',
        _title_default: '商品中心',
      },
      {
        path: '/shop/notice/detail',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__shopList__components__notice__detail" */ '../shopList/components/notice/detail'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../shopList/components/notice/detail').default,
        title: '公告详情',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '公告详情',
        _title_default: '商品中心',
      },
      {
        path: '/shop/banner',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__shopList__components__bannerDetail__index" */ '../shopList/components/bannerDetail/index'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../shopList/components/bannerDetail/index').default,
        title: 'banner详情',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: 'banner详情',
        _title_default: '商品中心',
      },
      {
        path: '/shop/goodList',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__shopList__components__goodList__goodList" */ '../shopList/components/goodList/goodList'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../shopList/components/goodList/goodList').default,
        title: '商品列表',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '商品列表',
        _title_default: '商品中心',
      },
    ],
    _title: '商品中心',
    _title_default: '商品中心',
  },
  {
    path: '/shopCart',
    routes: [
      {
        path: '/shopCart',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__shopCart" */ '../shopCart'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../shopCart').default,
        title: '购物车',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '购物车',
        _title_default: '商品中心',
      },
      {
        path: '/shopCart/comfrimOrder',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__shopCart__comfrimOrder" */ '../shopCart/comfrimOrder'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../shopCart/comfrimOrder').default,
        title: '确认订单',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '确认订单',
        _title_default: '商品中心',
      },
    ],
    _title: '商品中心',
    _title_default: '商品中心',
  },
  {
    path: '/subscribe',
    routes: [
      {
        path: '/subscribe/list',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__subscribe__list" */ '../subscribe/list'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../subscribe/list').default,
        title: '订阅列表',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '订阅列表',
        _title_default: '商品中心',
      },
      {
        path: '/subscribe/detail',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__subscribe__detail" */ '../subscribe/detail'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../subscribe/detail').default,
        title: '续费管理',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '续费管理',
        _title_default: '商品中心',
      },
      {
        path: '/subscribe/payRecord',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__subscribe__payRecord" */ '../subscribe/payRecord'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../subscribe/payRecord').default,
        title: '自动订阅扣费记录',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '自动订阅扣费记录',
        _title_default: '商品中心',
      },
      {
        path: '/subscribe/pay',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__SubscribePay__index" */ '../order/SubscribePay/index'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/SubscribePay/index').default,
        title: '收银台',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '收银台',
        _title_default: '商品中心',
      },
      {
        path: '/subscribe/transferToDetail',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__subscribe__TransferToDetail__index" */ '../subscribe/TransferToDetail/index'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../subscribe/TransferToDetail/index').default,
        title: '商品详情',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '商品详情',
        _title_default: '商品中心',
      },
      {
        path: '/subscribe/code',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__order__subscribeCode" */ '../order/subscribeCode'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../order/subscribeCode').default,
        title: '收银台',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '收银台',
        _title_default: '商品中心',
      },
      {
        component: __IS_BROWSER
          ? dynamic({
              loader: () => import(/* webpackChunkName: "p__404" */ '../404'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../404').default,
        exact: true,
        _title: '商品中心',
        _title_default: '商品中心',
      },
    ],
    _title: '商品中心',
    _title_default: '商品中心',
  },
  {
    path: '/toMarketing',
    routes: [
      {
        path: '/toMarketing/index',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__toMarketing__index" */ '../toMarketing/index'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../toMarketing/index').default,
        title: '',
        exact: true,
        _title: '商品中心',
        _title_default: '商品中心',
      },
    ],
    _title: '商品中心',
    _title_default: '商品中心',
  },
  {
    path: '/home',
    routes: [
      {
        path: '/home',
        component: __IS_BROWSER
          ? dynamic({
              loader: () => import(/* webpackChunkName: "p__home" */ '../home'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../home').default,
        title: '叫叫商城',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '叫叫商城',
        _title_default: '商品中心',
      },
      {
        path: '/home/classify',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__home__classify" */ '../home/classify'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../home/classify').default,
        title: '商品列表',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '商品列表',
        _title_default: '商品中心',
      },
      {
        path: '/home/changeGift',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__home__changeGift" */ '../home/changeGift'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../home/changeGift').default,
        title: '更换心愿礼',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '更换心愿礼',
        _title_default: '商品中心',
      },
    ],
    _title: '商品中心',
    _title_default: '商品中心',
  },
  {
    path: '/activity',
    routes: [
      {
        path: '/activity/index',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__activity__index" */ '../activity/index'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../activity/index').default,
        title: '',
        exact: true,
        _title: '商品中心',
        _title_default: '商品中心',
      },
    ],
    _title: '商品中心',
    _title_default: '商品中心',
  },
  {
    path: '/userVerify',
    routes: [
      {
        path: '/userVerify',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__userVerify" */ '../userVerify'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../userVerify').default,
        title: '用户身份验证',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '用户身份验证',
        _title_default: '商品中心',
      },
      {
        path: '/userVerify/result',
        component: __IS_BROWSER
          ? dynamic({
              loader: () =>
                import(/* webpackChunkName: "p__userVerify__result" */ '../userVerify/result'),
              loading: require('/home/workspace/code/src/components/Loading')
                .default,
            })
          : require('../userVerify/result').default,
        title: '用户身份验证',
        exact: true,
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '用户身份验证',
        _title_default: '商品中心',
      },
    ],
    _title: '商品中心',
    _title_default: '商品中心',
  },
  {
    component: __IS_BROWSER
      ? dynamic({
          loader: () => import(/* webpackChunkName: "p__404" */ '../404'),
          loading: require('/home/workspace/code/src/components/Loading')
            .default,
        })
      : require('../404').default,
    exact: true,
    _title: '商品中心',
    _title_default: '商品中心',
  },
];
window.g_routes = routes;
const plugins = require('umi/_runtimePlugin');
plugins.applyForEach('patchRoutes', { initialValue: routes });

export { routes };

export default class RouterWrapper extends React.Component {
  unListen() {}

  constructor(props) {
    super(props);

    // route change handler
    function routeChangeHandler(location, action) {
      plugins.applyForEach('onRouteChange', {
        initialValue: {
          routes,
          location,
          action,
        },
      });
    }
    this.unListen = history.listen(routeChangeHandler);
    routeChangeHandler(history.location);
  }

  componentWillUnmount() {
    this.unListen();
  }

  render() {
    const props = this.props || {};
    return <Router history={history}>{renderRoutes(routes, props)}</Router>;
  }
}
